(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const body = drawer.querySelector('[data-cart-body]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');
  const checkout = drawer.querySelector('[data-cart-checkout]');
  const notice = drawer.querySelector('[data-cart-notice]');
  const status = drawer.querySelector('[data-cart-status]');
  const count = document.querySelector('[data-cart-count]');
  const root = drawer.dataset.root || '/';
  let opener, busy = false, scrollY = 0, currentCart;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: currency || 'USD'}).format(cents / 100);
  const el = (tag, className, text) => { const n = document.createElement(tag); if (className) n.className = className; if (text != null) n.textContent = text; return n; };
  const link = (url) => { try { const u = new URL(url, location.origin); return u.origin === location.origin ? u.href : '#'; } catch { return '#'; } };
  const announce = text => { status.textContent = text; };
  const setBusy = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-cart-change], [data-cart-upsell-add]').forEach(b => b.disabled = value);
    checkout.toggleAttribute('aria-disabled', value || !currentCart?.item_count);
  };
  function open(trigger) {
    if (drawer.open) return;
    opener = trigger || document.activeElement;
    scrollY = window.scrollY;
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add('cart-open');
    drawer.showModal();
    drawer.querySelector('[data-cart-close]').focus();
  }
  function close() {
    drawer.close();
    document.body.classList.remove('cart-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    if (opener?.isConnected) opener.focus();
  }
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials: 'same-origin', ...options, headers: {Accept: 'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We could not update your bag. Please try again.');
    return data;
  }
  function render(cart) {
    currentCart = cart;
    body.replaceChildren();
    if (count) { count.textContent = cart.item_count; count.hidden = !cart.item_count; }
    subtotal.textContent = money(cart.total_price, cart.currency);
    checkout.hidden = !cart.item_count;
    const threshold = Number(drawer.dataset.shippingThreshold || 0);
    const freeShipping = cart.item_count > 0 && drawer.dataset.shippingEnabled === 'true' && cart.currency === 'USD' && threshold > 0 && cart.total_price >= threshold;
    notice.hidden = !freeShipping;
    notice.textContent = freeShipping ? 'Free standard shipping unlocked.' : '';
    if (!cart.item_count) {
      const empty = el('div', 'cart-empty');
      empty.append(el('span', 'cart-empty-icon', '✳'), el('h3', '', 'A little play is waiting.'), el('p', '', 'Find their next favorite toy.'));
      const browse = el('button', 'cta', 'Keep exploring'); browse.type = 'button'; browse.addEventListener('click', close); empty.append(browse); body.append(empty);
      return;
    }
    cart.items.forEach(item => {
      const row = el('article', 'drawer-item');
      if (item.image) { const img = el('img'); img.src = item.image; img.alt = item.product_title; img.width = 92; img.height = 92; row.append(img); }
      const content = el('div', 'drawer-item-content');
      const title = el('a', 'drawer-item-title', item.product_title); title.href = link(item.url); content.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') content.append(el('p', 'drawer-item-variant', item.variant_title));
      Object.entries(item.properties || {}).filter(([k,v])=> !k.startsWith('_') && k !== 'Free gifts' && v).forEach(([k,v]) => content.append(el('p','drawer-item-property',`${k}: ${v}`)));
      (item.line_level_discount_allocations || []).forEach(d => content.append(el('p', 'drawer-item-discount', d.discount_application.title)));
      const controls = el('div', 'drawer-item-controls');
      const qty = el('div', 'drawer-qty');
      for (const [label, delta, text] of [['Decrease quantity',-1,'−'],['Increase quantity',1,'+']]) {
        const b = el('button', '', text); b.type='button'; b.setAttribute('aria-label',`${label} for ${item.product_title}`); b.dataset.cartChange='';
        b.addEventListener('click',()=>change(item.key,item.quantity+delta)); qty.append(b);
        if (delta === -1) qty.append(el('span','',String(item.quantity)));
      }
      const remove = el('button', 'drawer-remove', 'Remove'); remove.type='button'; remove.dataset.cartChange=''; remove.setAttribute('aria-label', `Remove ${item.product_title}`); remove.addEventListener('click',()=>change(item.key,0));
      controls.append(qty,remove); content.append(controls); row.append(content);
      const price = el('div','drawer-item-price');
      if (item.original_line_price > item.final_line_price) price.append(el('s','',money(item.original_line_price,cart.currency)));
      price.append(el('strong','',money(item.final_line_price,cart.currency))); row.append(price);
      const giftText = item.properties?.['Free gifts'];
      if (giftText) {
        const match = String(giftText).match(/^(\d+) colorful play springs \+ (\d+) crinkle balls$/);
        const gifts = el('div','cart-gifts');
        const heading = el('div','cart-gifts-heading');
        const giftCount = match ? (Number(match[1]) + Number(match[2])) * item.quantity : null;
        heading.append(el('strong','', giftCount ? `${giftCount} free gifts included` : 'Your free gifts'), el('span','cart-gifts-zero',money(0,cart.currency)));
        gifts.append(heading);
        if (match) {
          [['spring','Play springs',Number(match[1])*item.quantity],['crinkle','Crinkle balls',Number(match[2])*item.quantity]].forEach(([kind,name,qty]) => {
            const gift = el('div','cart-gift');
            const icon = el('img', 'cart-gift-illustration'); icon.src = kind === 'spring' ? drawer.dataset.giftSpring : drawer.dataset.giftCrinkle; icon.alt = name + ' illustration'; icon.width = 56; icon.height = 42;
            const label = el('span','cart-gift-label',`${qty} × ${name}`);
            const free = el('span','cart-gift-free','FREE'); gift.append(icon,label,free);gifts.append(gift);
          });
        } else gifts.append(el('p','cart-gift-label',String(giftText)));
        row.append(gifts);
      }
      body.append(row);
    });
    renderUpsell(cart);
  }
  const upsellProducts = new Map();
  const upsellChoices = [
    {handle: 'pp-tailspin', description: 'A rolling ball with a wiggly tail to chase.'},
    {handle: 'pp-flutterbug', description: 'A soft butterfly with wings that flap.'}
  ];
  async function renderUpsell(cart) {
    for (const choice of upsellChoices) {
      if (cart.items.some(item => item.handle === choice.handle || item.url?.split('?')[0].endsWith('/' + choice.handle))) continue;
      try {
        if (!upsellProducts.has(choice.handle)) upsellProducts.set(choice.handle, request('products/' + choice.handle + '.js').catch(error => { upsellProducts.delete(choice.handle); throw error; }));
        const product = await upsellProducts.get(choice.handle);
        if (currentCart !== cart) return;
        const variant = product.variants?.[0];
        if (!variant?.available || cart.items.some(item => item.product_id === product.id)) continue;
        const card = el('section', 'cart-upsell');
        card.setAttribute('aria-label', 'Add a little extra play');
        card.append(el('p', 'cart-upsell-eyebrow', 'A little extra play?'));
        const row = el('div', 'cart-upsell-row');
        const image = el('img'); image.src = product.featured_image || product.images?.[0] || ''; image.alt = product.title + ' in action'; image.width = 76; image.height = 76; image.loading = 'lazy';
        const details = el('div', 'cart-upsell-details');
        const title = el('a', 'drawer-item-title', product.title); title.href = link(root + 'products/' + choice.handle);
        details.append(title, el('p', 'cart-upsell-description', choice.description), el('p', 'cart-upsell-offer', variant.title));
        const add = el('button', 'cart-upsell-add', 'Add · ' + money(variant.price, cart.currency));
        add.type = 'button'; add.dataset.cartUpsellAdd = ''; add.disabled = busy;
        add.setAttribute('aria-label', 'Add ' + product.title + ' — ' + variant.title + ' for ' + money(variant.price, cart.currency));
        add.addEventListener('click', async () => {
          if (busy) return;
          setBusy(true); add.textContent = 'Adding…'; announce('Adding ' + product.title + '…');
          let added = false;
          try {
            await request('cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: variant.id, quantity: 1}]})});
            added = true;
            await refresh(); announce(product.title + ' added to your bag.');
            drawer.querySelector('[data-cart-close]').focus();
          } catch (error) {
            announce(added ? 'Added to your bag. Close and reopen your bag to refresh it.' : error.message);
            if (added) card.remove();
            else add.textContent = 'Add · ' + money(variant.price, cart.currency);
          } finally { setBusy(false); }
        });
        row.append(image, details); card.append(row, add); body.append(card);
        return;
      } catch { if (currentCart !== cart) return; }
    }
  }
  async function refresh() { const cart = await request('cart.js'); render(cart); return cart; }
  async function change(key, quantity) {
    if (busy) return;
    setBusy(true); announce('Updating your bag…');
    try { render(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})})); announce('Bag updated.'); }
    catch (error) { announce(error.message); }
    finally { setBusy(false); drawer.querySelector('[data-cart-close]').focus(); }
  }
  document.querySelectorAll('a[href="/cart"], [data-cart-open]').forEach(trigger => trigger.addEventListener('click', async event => {
    event.preventDefault(); if (busy) return; open(trigger); setBusy(true); announce('Loading your bag…');
    try { await refresh(); announce(''); } catch (error) { announce(error.message); } finally { setBusy(false); }
  }));
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault(); if (busy) return;
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) {button.disabled = true; button.textContent = 'Adding…';}
    setBusy(true);
    const message = form.querySelector('.message');
    if (message) message.textContent = '';
    let added = false;
    try {
      await request('cart/add.js',{method:'POST',body:new FormData(form)}); added = true;
      await refresh(); open(button); announce('Added to your bag.');
    } catch(error) {
      const text = added ? 'Added to your bag, but the bag could not refresh. Open your bag to try again.' : error.message;
      if (message) {message.textContent = text; message.classList.add('visible');} else {open(button); announce(text);}
    } finally {setBusy(false); if (button) {button.disabled=false; button.textContent=original;}}
  }));
  drawer.querySelector('[data-cart-close]').addEventListener('click',close);
  drawer.addEventListener('cancel',event=>{event.preventDefault();close();});
  drawer.addEventListener('click',event=>{if(event.target === drawer) {const r=drawer.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right)close();}});
  checkout.addEventListener('click',event=>{if(busy || !currentCart?.item_count)event.preventDefault();});
})();
